import { Box, Button, Heading, Stack } from "@chakra-ui/react";
import BlogCards from "./blogCards/blogCards";

import { useNavigate } from "react-router-dom";
import { getLatestPosts } from "../../data/blogPosts";

// Homepage blog preview: latest curated posts from the static data source.
const Blog = () => {
  const navigate = useNavigate();
  const posts = getLatestPosts(6);

  return (
    <Box
      data-aos="fade-up"
      // marginTop="100px"
      marginBottom="80px"
      padding={["2rem 2rem", "2rem 6rem"]}
    >
      <Stack
        direction={["column", "row"]}
        marginTop="7rem"
        marginBottom="2rem"
        alignItems="center"
        justifyContent="space-between"
        gap="2rem"
      >
        <Box>
          <Heading
            marginLeft={["0px", "0px", "0px", "50px"]}
            lineHeight="40px"
            size="lg"
            className="bold"
            fontSize={["3.5em", "4em", "4em", "7rem"]}
            color="#290F44"
            opacity="0.1"
          >
            READ BLOG
          </Heading>
          <Heading
            className="bold"
            maxW="600px"
            fontWeight="600"
            fontSize="1.9rem"
            color="#290F44"
            textAlign={["center", "initial"]}
          >
            STAY INFORMED <br /> ON OUR LATEST NEWS{" "}
            <Box
              display={"inline-block"}
              w="10px"
              h="10px"
              borderRadius="50%"
              bg="#00FE98"
            />
          </Heading>
        </Box>
        <Button
          mt={10}
          width={170}
          padding="1.5rem 3rem"
          borderRadius="5px"
          bg="#290F44"
          _hover={{ background: "#00FE98" }}
          color="#fff"
          fontSize="14px"
          onClick={() => navigate("/blog")}
          boxShadow={"13px 20px 20px 0px #290f443b;"}
        >
          VIEW ALL POSTS
        </Button>
      </Stack>
      <BlogCards blogs={posts} />
    </Box>
  );
};

export default Blog;
